// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/takeoff-landing-distance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/takeoff-landing-distance/takeoff-landing-distance.js';
import g1 from '../lessons/aeronautics/takeoff-landing-distance/takeoff-landing-facts.js';

mount([g0, g1]);
